<template>
  <el-dialog
    v-model="isFormVisible"
    width="40%"
    title="Apply to the event"
    @close="handleCancel"
  >
    <event-preview :event-data="eventData" :is-active="false" />

    <el-form
      :rules="applicationFormRules"
      :model="applicationForm"
      ref="applicationForm"
    >
      <el-form-item
        prop="applicationComment"
        :error="applicationFormErrors.comments"
        label="Comment"
      >
        <el-input v-model="applicationForm.comments" type="textarea" :rows="4">
        </el-input>
      </el-form-item>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleCancel">Cancel</el-button>
        <el-button
          type="primary"
          @click="requestSendApplicationToEvent"
          :disabled="isButtonDisabled('join-event')"
        >
          Send application
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import EventPreview from '@/components/events/EventPreview.vue';
import { sendApplicationToEvent } from '@/api/events.js';
import { showMessage } from '@/utils/messages.js';
import { parseErrorsByFields } from '@/utils/index.js';
import { disableButton } from '@/mixins/disableButton.js';

export default {
  name: 'JoinEvent',
  props: {
    eventData: {
      type: Object,
      required: true,
    },
    eventId: {
      type: Number,
      required: true,
    },
  },
  mixins: [disableButton],
  components: {
    EventPreview,
  },
  data() {
    return {
      isFormVisible: true,
      applicationForm: { comments: null },
      applicationFormRules: {
        applicationComment: [
          { required: false, trigger: 'input', message: '' },
        ],
      },
      applicationFormErrors: { comments: null },
    };
  },
  methods: {
    showMessage,
    parseErrorsByFields,
    async requestSendApplicationToEvent() {
      this.disableButton('join-event');
      const { eventId } = this;
      const { comments } = this.applicationForm;

      const { data, success, errors } = await sendApplicationToEvent({
        eventId,
        comments,
      });
      this.enableButton('join-event');

      if (success) {
        this.showMessage({
          type: 'success',
          message: 'Application has been sent',
        });
        this.isFormVisible = false;
      } else if (errors) {
        this.applicationFormErrors = {
          ...this.applicationFormErrors,
          ...this.parseErrorsByFields(errors),
        };
      }
    },
    handleCancel() {
      this.$emit('on-cancel');
    },
  },
};
</script>
